import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMsInterview = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 20,
	viewBox: "0 0 23 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.9444 5.74523H20.3889C20.6836 5.74523 20.9662 5.86229 21.1746 6.07066C21.3829 6.27904 21.5 6.56165 21.5 6.85634V19.0786L17.7967 16.0019C17.5968 15.836 17.3453 15.7452 17.0856 15.7452H8.16667C7.87198 15.7452 7.58937 15.6282 7.38099 15.4198C7.17262 15.2114 7.05556 14.9288 7.05556 14.6341V11.3008M15.9444 5.74523V2.41189C15.9444 2.11721 15.8274 1.83459 15.619 1.62622C15.4106 1.41784 15.128 1.30078 14.8333 1.30078H2.61111C2.31643 1.30078 2.03381 1.41784 1.82544 1.62622C1.61706 1.83459 1.5 2.11721 1.5 2.41189V14.6341L5.20333 11.5563C5.40333 11.3919 5.65444 11.3008 5.91444 11.3008H7.05556M15.9444 5.74523V10.1897C15.9444 10.4844 15.8274 10.767 15.619 10.9753C15.4106 11.1837 15.128 11.3008 14.8333 11.3008H7.05556",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgMsInterview);
export { ForwardRef as ReactComponent };
